// src/utils/EventSubscriber.ts
import { FlatfileClient } from "@flatfile/api";
import PubNub from "pubnub";
var fetchEventToken = async (client, spaceId) => {
  const { data } = await client.events.getEventToken({ spaceId });
  if (!data) {
    throw new Error(`Failed to retrieve event token for space ID: ${spaceId}`);
  }
  if (!data.subscribeKey) {
    throw new Error("Missing subscribe key in event token response");
  }
  if (!data.accountId) {
    throw new Error("Missing account ID in event token response");
  }
  if (!data.token) {
    throw new Error("Missing token in event token response");
  }
  return data;
};
var EventSubscriber = class {
  static async getClient(spaceId, accessToken, apiUrl) {
    const flatfile = new FlatfileClient({
      token: accessToken,
      environment: `${apiUrl || "https://platform.flatfile.com/api"}/v1`
    });
    try {
      const data = await fetchEventToken(flatfile, spaceId);
      const pubnub = new PubNub({
        subscribeKey: data.subscribeKey,
        uuid: data.accountId
      });
      pubnub.setToken(data.token);
      const handleReconnect = async () => {
        console.log("Reconnecting...");
        const data2 = await fetchEventToken(flatfile, spaceId);
        if (data2.token == null) {
          throw new Error("Token is null or undefined");
        }
        pubnub.setToken(data2.token);
        pubnub.reconnect();
      };
      const handleAuthentication = async () => {
        console.log("Authenticating...");
        const data2 = await fetchEventToken(flatfile, spaceId);
        if (!data2.token) {
          throw new Error("Error fetching token when re-authenticating");
        }
        pubnub.setToken(data2.token);
        pubnub.subscribe({
          channels: [`space.${spaceId}`]
        });
      };
      pubnub.addListener({
        status: function(statusEvent) {
          if (statusEvent.category === "PNNetworkUpCategory") {
            handleReconnect();
          }
        }
      });
      pubnub.addListener({
        status: function(statusEvent) {
          if (statusEvent.category === "PNNetworkIssuesCategory") {
            handleAuthentication();
          }
        }
      });
      return { pubnub, token: data.token };
    } catch (e) {
      throw new Error(`Failed to get event token: ${e}`);
    }
  }
};

// src/utils/getErrorMessage.ts
function getErrorMessage(error) {
  if (error instanceof Error)
    return error.message;
  return String(error);
}

// src/utils/initializePubnub.ts
var initializePubnub = async ({
  spaceId,
  accessToken,
  apiUrl = "https://platform.flatfile.com/api"
}) => {
  try {
    const response = await EventSubscriber.getClient(
      spaceId,
      accessToken,
      apiUrl
    );
    if (!response) {
      throw new Error("Failed to obtain response from Event Subscriber");
    }
    if (!response.pubnub) {
      throw new Error(
        "Failed to obtain pubnub object from Event Subscriber response"
      );
    }
    return response.pubnub;
  } catch (e) {
    throw new Error(`Failed to initialize Pubnub: ${getErrorMessage(e)}`);
  }
};
export {
  EventSubscriber,
  fetchEventToken,
  getErrorMessage,
  initializePubnub
};
